import React from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";

// components
import MotivationalCard from "./MotivationalCard";

// context
import {} from "../../hooks/";

const MotivationalCarousel = ({ motivations, onChange }) => {
  return (
    <Carousel
      showArrows={false}
      autoPlay
      infiniteLoop
      showThumbs={false}
      showStatus={false}
      width={"100%"}
      style={{ margin: 0 }}
      onChange={(index) => {
        onChange(index);
      }}
      onClickItem={(index) => {
        // onClick(index);
      }}
    >
      {motivations?.map((item, index) => (
        <MotivationalCard
          previousItem={
            motivations[index - 1 < 0 ? motivations.length - 1 : index - 1]
          }
          nextItem={
            motivations[index + 1 >= motivations.length ? 0 : index + 1]
          }
          item={item}
          key={item._id}
        />
      ))}
    </Carousel>
  );
};

export default MotivationalCarousel;
